import { Component, ViewEncapsulation, ChangeDetectionStrategy, OnChanges, Input, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { PhxOrientation, PhxContrast, PhxAlertIntent, PhxAlertType, PhxSize } from './phx-alert.types';
import { CheckCircle, Cross, ErrorTriangle, LetterI } from './../icon/icon-map';

@Component({
  selector: 'phx-alert',
  styleUrls: ['./phx-alert.component.scss'],
  templateUrl: './phx-alert.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-alert',
    '[class.phx-horizontal]': 'phxOrientation === "horizontal"',
    '[class.phx-vertical]': 'phxOrientation === "vertical"',
    '[class.phx-contrast-low]': 'phxContrast === "low"',
    '[class.phx-contrast-high]': 'phxContrast === "high"',
    '[class.phx-closable]': 'phxClosable',
    '[class.phx-has-icon]': 'phxHasIcon',
    '[class.phx-alert-inline]': 'phxAlertType === "inline"',
    '[class.phx-alert-banner]': 'phxAlertType === "banner"',
    '[class.phx-alert-toast]': 'phxAlertType === "toast"',
    '[class.phx-alert-card]': 'phxAlertType === "card"',
    '[class.phx-alert-settings-banner]': 'phxAlertType === "settings-banner"',
    '[class.phx-alert-info]': 'phxAlertIntent === "info"',
    '[class.phx-alert-positive]': 'phxAlertIntent === "positive"',
    '[class.phx-alert-warning]': 'phxAlertIntent === "warning"',
    '[class.phx-alert-negative]': 'phxAlertIntent === "negative"',
    '[class.phx-alert-caution]': 'phxAlertIntent === "caution"',
    '[class.phx-alert-closed]': 'isClosed',
    '[class.phx-size-small]': 'phxSize === "small" && phxAlertType === "inline"',
  },
})
export class PhxAlertComponent implements OnChanges {
  @Input() public phxOrientation: PhxOrientation = 'horizontal';
  @Input() public phxContrast: PhxContrast = 'low';
  @Input() public phxClosable: boolean = false;
  @Input() public phxHasIcon: boolean = true;
  @Input() public phxAlertIntent: PhxAlertIntent = 'info';
  @Input() public phxAlertType: PhxAlertType = 'inline';
  @Input() public phxSize: PhxSize = 'default';
  @Input() public phxIcon: string;

  @Output() public phxOnClose: EventEmitter<void> = new EventEmitter<void>();
  public prefixIcon: string = LetterI;
  public readonly crossIcon: string = Cross;
  public isClosed: boolean = false;


  constructor(
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { phxAlertIntent, phxAlertType, phxIcon } = changes;

    if (phxAlertIntent || phxIcon) {
      this.prefixIcon = this.getPrefixIcon();
    }

    if (phxAlertType && phxAlertType.currentValue === 'toast') {
      this.phxContrast = 'high';
    }

    this.cdr.detectChanges();
  }

  private getPrefixIcon(): string {
    if (this.phxIcon) return this.phxIcon;

    switch (this.phxAlertIntent) {
      case 'info':
        return LetterI;
      case 'positive':
        return CheckCircle;
      case 'warning':
      case 'caution':
      case 'negative':
        return ErrorTriangle;
    }
  }

  public onClosed(): void {
    this.isClosed = true;
    this.phxOnClose.emit();
    this.cdr.detectChanges();
  }
}
